export const GCS_BASE_URL = 'https://storage.googleapis.com';
export const GCS_DEFAULT_BUCKET = process.env.REACT_APP_GCS_DEFAULT_BUCKET
  ? process.env.REACT_APP_GCS_DEFAULT_BUCKET
  : 'pf-bucket-default-prod';
